// @flow
import bemify from 'bemify-js';
import React from 'react';
import { Spinner } from '@zapier/design-system';
import 'app/team-account/components/App.scss';
const bem = bemify('team-trial-start-app');
// App used to contain the old wizard for setting up a team account.
// Now a loading spinner for the redirect until we can remove it.
const App = () => {
  return (
    <div className={bem()}>
      {' '}
      <Spinner size="medium" />
    </div>
  );
};

export default App;
